export default {
  state: {
    cartNum: 0,
  },
  mutations: {
    setCartNum(state, num) {
      state.cartNum = num;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js